import { alpha } from '@mui/material'
import type { OmuiSegmentedControlComponent } from '../../../SegmentedControl'

// TODO: should be a palette value or theme util
const BACKGROUND_ALPHA = 0.32
// TODO: should use theme border radius values once set up
const CONTAINER_BORDER_RADIUS = 8
const BUTTON_BORDER_RADIUS = 7
const SELECTED_SHADOW_ALPHA = 0.1

export const OmuiSegmentedControl: OmuiSegmentedControlComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: alpha(theme.palette.neutralLight[500], BACKGROUND_ALPHA),
      borderRadius: CONTAINER_BORDER_RADIUS,
      padding: 1,
      '& .MuiToggleButton-root': {
        ...theme.typography.Body14pxMedium,
        lineHeight: 1.45,
        textTransform: 'none',
        paddingBlock: theme.spacing(1),
        paddingInline: theme.spacing(2),
        border: 'none',
        borderRadius: BUTTON_BORDER_RADIUS,
        backgroundColor: 'transparent',
        color: theme.palette.neutralDark[500],
        '& .MuiSvgIcon-root': {
          width: theme.spacing(4),
          height: theme.spacing(4),
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.neutralLight[0],
          // TODO: update shadow scale and apply here in place of hardcoded values - INTA-1058
          boxShadow: `0px 1px 4px 0px ${alpha(theme.palette.neutralDark[500], SELECTED_SHADOW_ALPHA)}`,
          color: theme.palette.neutralDark[500],
          '&:hover': { backgroundColor: theme.palette.neutralLight[0] },
        },
        '&:hover': { backgroundColor: 'transparent' },
      },
      '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': { marginLeft: 0 },
    }),
  },
}
